import React, { useState, useEffect } from 'react';
import { useDocumentTitle, useClipboard, useLocalStorage } from 'xooks';
import { useTranslation } from 'react-i18next';

import SystemLayout from 'layouts/SystemLayout';
import generateText from './generate-text';
import Settings from './Settings/Settings';
import Preview from './Preview/Preview';

const INITIAL_VALUES = {
  length: 3,
  type: 'lorem',
};

const LoremIpsum = () => {
  const { t } = useTranslation();
  const clipboard = useClipboard();
  const ls = useLocalStorage({ key: 'lorem-ipsum', delay: 1000 });
  const initialValues = ls.retrieve() || INITIAL_VALUES;

  const [type, setType] = useState(initialValues.type || 'lorem');
  const [length, setLength] = useState(initialValues.length || 3);
  const [text, setText] = useState(generateText(type, length));

  useDocumentTitle(t('loremIpsumGenerator.pageTitle'));

  useEffect(() => {
    ls.save({ type, length });
    clipboard.reset();

    return ls.cancel;
  }, [type, length, ls, clipboard]);

  const handleSubmit = () => {
    const generatedText = generateText(type, length);
    clipboard.copy(generatedText);
    setText(generatedText);
  };

  return (
    <SystemLayout>
      <Settings
        type={type}
        length={length}
        onLengthChange={setLength}
        onTypeChange={setType}
        onSubmit={handleSubmit}
        copied={clipboard.copied}
      />
      <Preview text={text} />
    </SystemLayout>
  );
};

export default LoremIpsum;
